<div class="expertises">
  <div class="row">
    <div class="number" [class.red]="expertises?.length === 0" [class.disabled]="!btnIsActive">7</div>
    <div class="title">Заключение экспертизы
      <div class="required">*</div>
    </div>
    <div class="loading-wrapper" *ngIf="loading">
      <div class="loading"></div>
    </div>
    <div *ngIf="!loading" class="action" matRipple (click)="btnIsActive ? newExpertise() : ''" [class.disabled]="!btnIsActive"
         [matTooltip]="tooltip"
         [matTooltipDisabled]="btnIsActive"
    >
      <span class="icon-plus">+</span>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <ng-container *ngFor="let item of isActiveExpertises; let i = index;">
      <app-new-expertise [objectName]="objectName"
                         [objectId]="livingComplexID"
                         [regionID]="regionID"
                         [sampleSignInfo]="sampleSignInfo"
                         [index]="i+1"
                         [expertise]="item"
                         [expertiseTypes]="expertiseTypes"
                         (isRemove)="getRemovedIndex(i, item)"
                         (isSignSampleUploaded)="updateSignSample($event)"
                         (isCreated)="getCreated($event)"
                         (isActiveChange)="getActiveChange($event, item)">
      </app-new-expertise>
    </ng-container>

    <mat-accordion>
      <ng-container *ngFor="let item of isNotActiveExpertises; let i = index; trackBy: trackByExpertise">
        <!--hideToggle-->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="status" [class.active]="item?.isActive"> 7.{{ isActiveExpertises.length + i + 1 }}
                | {{ item?.isActive ? 'Действующая' : 'Недействующая' }}
              </div>
            </mat-panel-title>
            <mat-panel-description>
              <div class="desc">
                № {{ item?.number }}
              </div>
              <div class="desc">
                от {{ item?.date | dateFormat: "1" | uppercase }}
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <app-new-expertise
            [objectName]="objectName"
            [objectId]="livingComplexID"
            [regionID]="regionID"
            [sampleSignInfo]="sampleSignInfo"
            [index]="isActiveExpertises.length+i+1"
            [expertise]="item"
            [expertiseTypes]="expertiseTypes"
            (isRemove)="getRemovedIndex(i, item)"
            (isSignSampleUploaded)="updateSignSample($event)"
            (isActiveChange)="getActiveChange($event, item)">
          </app-new-expertise>


        </mat-expansion-panel>
      </ng-container>

    </mat-accordion>
  </ng-container>
</div>
